import React, { memo, useEffect, useState } from 'react'

const Icon = ({ size, icon_name, tooltip = undefined, onClick = undefined, cName = '' }) => {
  const [icon, setIcon] = useState('')

  useEffect(() => {
    let icon_svg = import(`./assets/${icon_name}.svg`)
    setIcon(icon_svg.default)
  }, [])

  useEffect(() => {
    let icon_svg = import(`./assets/${icon_name}.svg`)
    setIcon(icon_svg.default)
  }, [icon_name])

  if (tooltip) {
    return (
      <>
        <div className="image__position">
          <img src={icon}></img>

          <p className="icon_container">
            {tooltip}
            <span className="icon_container__arrow_up"></span>
          </p>
        </div>
      </>
    )
  }

  return <img className={cName ? cName : ''} onClick={onClick} src={icon} />
}

export default React.memo(Icon)
